import { Pane, Spinner } from "evergreen-ui";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Typography,
} from "@mui/material";

const CategoryForm = ({
  initialValues,
  handleChange,
  content,
  handleChangeEditor,
  categories,
  ustKategori,
  setUstKategori,
  errors,
  values,
}) => {
  return (
    <div className="grid grid-cols-1 gap-6">
      <FormControl fullWidth>
        <TextField
          sx={{ m: 0 }}
          size="small"
          margin="normal"
          required
          fullWidth
          id="title"
          label="Kategori Adı"
          name="title"
          autoComplete="title"
          onChange={handleChange}
          defaultValue={initialValues.title}
          key={initialValues.title}
          values={values.title}
          helperText={errors.title && errors.title}
          error={errors.title ? true : false}
        />
      </FormControl>
      <FormControl fullWidth>
        {categories.isLoading && (
      <div className="w-full flex justify-center items-center">
      <Pane>
        <Spinner marginX="auto" size={60} marginTop={25} marginBottom={50} />
        <Typography variant="h5" gutterBottom>
          İşlem Yapılıyor. Lütfen Bekleyniz...
        </Typography>
      </Pane>
    </div>
        )}
        {!categories.isLoading && (
          <>
            <InputLabel id="demo-simple-select-label">Üst Kategori</InputLabel>
            {!categories.isError && (
              <Select
                defaultValue=""
                key={""}
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={ustKategori}
                label="Üst Kategori"
                onChange={(e) => setUstKategori(e.target.value)}
              >
                <MenuItem value={0}>Üst Kategori Seçiniz</MenuItem>
                {categories.data.length > 0 &&
                  categories.data.map((row, i) => (
                    <MenuItem key={i} value={row.id}>
                      {row.title}
                    </MenuItem>
                  ))}
              </Select>
            )}
            {categories.isError && (
              <Select
                defaultValue={ustKategori}
                key={ustKategori}
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={ustKategori}
                label="Üst Kategori"
              >
                <MenuItem value={0}>Kategori Bulunamadı</MenuItem>
              </Select>
            )}
          </>
        )}
      </FormControl>
      <FormControl fullWidth>
        <TextField
          sx={{ m: 0 }}
          size="small"
          margin="normal"
          fullWidth
          id="page_title"
          label="Sayfa Başlık (TITLE)"
          name="page_title"
          autoComplete="page_title"
          onChange={handleChange}
          defaultValue={initialValues.page_title}
          key={initialValues.page_title}
          values={values.page_title}
          helperText={errors.page_title && errors.page_title}
          error={errors.page_title ? true : false}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          sx={{ m: 0 }}
          multiline
          rows={2}
          size="small"
          margin="normal"
          fullWidth
          id="page_description"
          label="Sayfa Açıklaması (DESCRİPTİON)"
          name="page_description"
          autoComplete="page_description"
          onChange={handleChange}
          defaultValue={initialValues.page_description}
          key={initialValues.page_description}
          values={values.page_description}
          helperText={errors.page_description && errors.page_description}
          error={errors.page_description ? true : false}
        />
      </FormControl>
      <FormControl fullWidth sx={{ mb: 9 }}>
        <ReactQuill
          value={content}
          onChange={handleChangeEditor}
          theme={"snow"}
        />
      </FormControl>
    </div>
  );
};

export default CategoryForm;
